<app-card-consulta 
  (update)="update.emit($event)" 
  [titulo]="titulo" 
  [idConsulta]='idConsulta' 
  [tipoConsulta]="tipoConsulta" 
  [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
>

    <ng-container *ngIf="consulta">
        <table class="table table-striped table-responsive-sm table-sm w-100 card-list-striped">
            <thead class="fw-500 text-info font-weight-bold">
                <th class="px-2">PERCENTUAL</th>
                <th class="px-2">PERÍODO</th>
                <th class="px-2">QUANTIDADE</th>
            </thead>
            <tbody>
                <tr *ngFor="let r of consulta?.registros">
                    <td class="px-2">{{ r?.percentual || msgNull }}</td>
                    <td class="px-2">{{ r?.periodo || msgNull }}</td>
                    <td class="px-2">{{ r?.quantidade || msgNull }}</td>
                </tr>
            </tbody>
        </table>
    </ng-container>
    
</app-card-consulta>